import React, { useState } from "react";
import { Button } from "../../components/Button/Button";
import Logo from "../../assets/images/akra_logo.png";
import { GetForgotPassword } from "../../api/api";


export const ForgotPassword = () => {
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [email, setEmail] = useState(null);
  const [emailResponse, setEmailResponse] = useState<any>(null);
  const [newResponse, setNewResponse] = useState<any>("");
  const [responseText, setResponseText] = useState(false);

  function handleChangeEmail(e: any) {
    setEmail(e.target.value);
  }

  function handlebtnClick() {
    setIsBtnLoading(true);
    GetForgotPassword(email)
      .then((response) => response?.json())

      .then((response) => {
        setEmailResponse(response?.errors?.[0]?.message ?? "");
        setResponseText(true);
        setIsBtnLoading(false);
      })
      .catch((error) => {
        setNewResponse(error);
        console.log("error: " + error);
        setIsBtnLoading(false);
        setEmailResponse("Email Sent Successfully");
      });
  }

  return (
    <main className="main h-100 w-100">
      <div className="container h-100">
        <div className="row h-100 mt-4">
          <div className="col-sm-10 col-md-8 col-lg-5 mx-auto d-table h-100 mt-4">
            <div className="d-table-cell align-middle mt-4">
              <div className="text-center mt-4">
                <h1 className="h2">Reset Your Password</h1>
                <p className="lead">Please enter your email address.</p>
              </div>

              <div className="card">
                <div className="card-body">
                  <div className="m-sm-4">
                    <div className="text-center">
                      <img
                        src={Logo}
                        alt="Linda Miller"
                        className="img-fluid"
                        width="100"
                        height="100"
                      />
                    </div>

                    <div className="my-3">
                      <label htmlFor="email" className="text-body">
                        Enter Email
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        onChange={(e) => handleChangeEmail(e)}
                      />
                    </div>

                    {responseText !== true ? (
                      <div className="text-success">{emailResponse}</div>
                    ) : (
                      <div className="text-danger">{emailResponse}</div>
                    )}

                    <div className="text-center mt-3">
                      <Button
                        type="submit"
                        className="btn-primary"
                        size="btn-lg"
                        children="Continue"
                        showLoading={isBtnLoading}
                        onClick={handlebtnClick}
                      />

                      {/* <!-- <button type="submit" className="btn btn-lg btn-primary">Sign in</button> --> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
